import { Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useEffect, useRef, useState } from 'react'

const useCustomStyle = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    padding: '5px 15px',
    fontSize: 12,
  },
}))

const OverflowTooltip = ({ title, style = {}, ...restProps }) => {
  const classes = useCustomStyle()

  const textElementRef = useRef()
  const [hoverStatus, setHoverStatus] = useState(false)

  // compare once and add resize listener on "componentDidMount"
  useEffect(() => {
    compareSize()
    window.addEventListener('resize', compareSize)
  }, [])

  // remove resize listener again on "componentWillUnmount"
  useEffect(
    () => () => {
      window.removeEventListener('resize', compareSize)
    },
    []
  )

  const compareSize = () => {
    const compare =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth
    setHoverStatus(compare)
  }

  return (
    <Tooltip
      placement="right-end"
      classes={classes}
      disableHoverListener={!hoverStatus}
      title={title}
      {...restProps}
    >
      <div className="truncate" ref={textElementRef} style={style}>
        {title}
      </div>
    </Tooltip>
  )
}
export default OverflowTooltip
